/* eslint-disable @typescript-eslint/restrict-template-expressions */
export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

export function Spinner({ size = 'lg' }: SpinnerProps) {
  return (
    <span className={`flex justify-center items-center `}>
      <span
        className={`
          spinner ease-linear rounded-full border-primary-lighten-40
          ${size === 'sm' && 'h-4 w-4 border-2 border-t-2'}
          ${size === 'md' && 'h-8 w-8 border-4 border-t-4'}
          ${size === 'lg' && 'h-16 w-16 border-4 border-t-4'}
        `}
        style={{ borderTopColor: '#004f99ff' }}
      ></span>
    </span>
  );
}

export default Spinner;
